import MarginTop from "../ConfigParameters/MarginTop";
import MarginBottom from "../ConfigParameters/MarginBottom";
import MarginLeft from "../ConfigParameters/MarginLeft";
import MarginRight from "../ConfigParameters/MarginRight";

export default class Margins {

    constructor(marginTopBottom = {value: 15, unit: 'px'}, marginLeftRight = {value: 30, unit: 'px'}) {

        let marginTop = new MarginTop();
        marginTop.setDefaultValue({...marginTopBottom});
        let marginBottom = new MarginBottom();
        marginBottom.setDefaultValue({...marginTopBottom});

        let marginLeft = new MarginLeft();
        marginLeft.setDefaultValue({...marginLeftRight});
        let marginRight = new MarginRight();
        marginRight.setDefaultValue({...marginLeftRight});
        
        return {
            ...(marginTop),
            ...(marginBottom),
            ...(marginLeft),
            ...(marginRight),
        };
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigCollections/Margins.js